import React, { Component } from 'react'
import { connect } from 'react-redux'
import TextField from 'material-ui/TextField';
import { api } from "../../../../api/index";
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';
import ActionDeleteForever from 'material-ui/svg-icons/action/delete-forever';
import ContentSave from 'material-ui/svg-icons/content/save';
import { loadCampaignSettings } from "../../../../api/settings/campaigns";

class AppSettingsCampaignsComponent extends Component {
	constructor(props) {
		super(props);

		this.removeSettingsField = this.removeSettingsField.bind( this );
		this.saveSettings = this.saveSettings.bind( this );
		this.addField = this.addField.bind( this );
	}
	
	componentDidMount() {
		loadCampaignSettings();
	}

	saveSettings() {
		api.settings.campaigns.saveSettings();
	}

	removeSettingsField( settingsProperty, nodeId ) {
		api.settings.campaigns.removeSettingsField( settingsProperty, nodeId );
	}

	addField( settingsProperty ) {
		api.settings.campaigns.addSettingsField(settingsProperty);
	}
	
	render() {
		return (
			<div className="medium-12 cell">
				<div className="grid-x grid-container grid-padding-x">
					<div className="small-12 cell">
						<h5>Types</h5>
					</div>
					<div className="medium-6 cell small-order-2 medium-order-1">
						<div className="grid-x grid-padding-x">
							{
								this.props.settings.types.map((type, key) => {
									return (
										<div className="cell" key={type.key}>
											<div className="grid-x">
												<div className="small-10 cell" key={key}>
													<label>
														<TextField
															onChange={api.settings.campaigns.updateSettingsValue}
															value={type.name}
															data-settings-property="types"
															name="name"
															fieldkey={key}
															fullWidth={true}
														/>
													</label>
												</div>
												<div className="small-2 cell text-right">
													<IconButton
														tooltip="Verwijderen"
														tooltipPosition="top-center"
														onClick={() => this.removeSettingsField( 'types', type.key)}
													>
														<ActionDeleteForever/>
													</IconButton>
												</div>
											</div>
										</div>
									)
								})
							}

							<div className="medium-12 cell text-right">
								<RaisedButton
									label="Type toevoegen"
									primary={true}
									onClick={() => this.addField('types')}
									fullWidth={true}
								/>
							</div>
						</div>
					</div>
					<div className="medium-6 cell small-order-1 medium-order-2">
						<p className="description">Types worden intern in het systeem gebruikt om bij de overzichten te kunnen filteren</p>
					</div>
				</div>
				<div className="settings--content--spacer"></div>
				<div className="grid-x grid-container grid-padding-x">
					<div className="small-12 cell">
						<h5>Waarover</h5>
					</div>
					<div className="medium-6 cell small-order-2 medium-order-1">
						<div className="grid-x grid-padding-x">
							{
								this.props.settings.subjects.map((type, key) => (
									<div className="cell" key={key}>
										<div className="grid-x">
											<div className="small-10 cell" key={key}>
												<label>
													<TextField onChange={api.settings.campaigns.updateSettingsValue} value={type.name} data-settings-property="subjects" name="name" fieldkey={key} fullWidth={true} />
												</label>
											</div>
											<div className="small-2 cell text-right">
												<IconButton
													tooltip="Verwijderen"
													tooltipPosition="top-center"
													onClick={() => this.removeSettingsField( 'subjects', type.key)}
												>
													<ActionDeleteForever />
												</IconButton>
											</div>
										</div>
									</div>
								))
							}

							<div className="medium-12 cell text-right">
								<RaisedButton
									label="Waarover toevoegen"
									primary={true}
									onClick={() => this.addField('subjects')}
									fullWidth={true}
								/>
							</div>
						</div>
					</div>
					<div className="medium-6 cell small-order-1 medium-order-2">
						<p className="description">Waarovers worden intern in het systeem gebruikt om bij de overzichten te kunnen filteren</p>
					</div>
				</div>
				<div className="settings--content--spacer"></div>
				<div className="grid-x grid-container grid-padding-x">
					<div className="small-12 cell">
						<h5>Opdrachtgevers</h5>
					</div>
					<div className="medium-6 cell small-order-2 medium-order-1">
						<div className="grid-x grid-padding-x">
							{
								this.props.settings.departments.map((type, key) => (
									<div className="cell" key={key}>
										<div className="grid-x">
											<div className="small-10 cell" key={key}>
												<label>
													<TextField onChange={api.settings.campaigns.updateSettingsValue} value={type.name} data-settings-property="departments" name="name" fieldkey={key} fullWidth={true} />
												</label>
											</div>
											<div className="small-2 cell text-right">
												<IconButton
													tooltip="Verwijderen"
													tooltipPosition="top-center"
													onClick={() => this.removeSettingsField( 'departments', type.key)}
												>
													<ActionDeleteForever />
												</IconButton>
											</div>
										</div>
									</div>
								))
							}

							<div className="medium-12 cell text-right">
								<RaisedButton
									label="Opdrachtgever toevoegen"
									primary={true}
									onClick={() => this.addField('departments')}
									fullWidth={true}
								/>
							</div>
						</div>
					</div>
					<div className="medium-6 cell small-order-1 medium-order-2">
						<p className="description">Opdrachtgevers worden intern in het systeem gebruikt om bij de overzichten te kunnen filteren</p>
					</div>
				</div>
				<div className="settings--content--spacer"></div>
				<div className="grid-x grid-container grid-padding-y">
					<div className="small-12 cell text-right">
						<RaisedButton
							label="Instellingen Opslaan"
							primary={true}
							onClick={this.saveSettings}
							fullWidth={true}
						/>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		settings: state.campaignSettings
	}
};

export default connect(mapStateToProps, {
	loadCampaignSettings
})(AppSettingsCampaignsComponent)


// WEBPACK FOOTER //
// ./src/application/components/settings/campaigns/index.js